/**
 * The project Validate has open. Off localhost, the engine logs behind traces
 * and call transcripts are read only for chats in a project the caller can
 * open (`authorizeLogRead` in the AI router), so those requests carry it. Set
 * by `ValidateStage`; a plain holder so the request helpers stay free of the
 * app's state machine.
 */
let projectId: string | undefined;

export const setValidateProject = (id: string | undefined) => {
  projectId = id;
};

export const validateProject = () => projectId;
